function SendIcon({ width = 20, height = 20 }) {
    return (
        <svg
            width={`${width}`}
            height={`${height}`}
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M18.9549 1.05576C18.8517 0.953161 18.7213 0.882124 18.579 0.851004C18.4368 0.819883 18.2886 0.829972 18.1519 0.880085L1.3268 6.99057C1.1817 7.04553 1.05677 7.14329 0.96862 7.27085C0.880465 7.39841 0.833252 7.54974 0.833252 7.70473C0.833252 7.85972 0.880465 8.01105 0.96862 8.13861C1.05677 8.26617 1.1817 8.36392 1.3268 8.41889L7.89623 11.0388L12.7449 6.18093L13.8232 7.2579L8.95162 12.1234L11.5825 18.6845C11.6391 18.8266 11.7372 18.9485 11.864 19.0343C11.9908 19.1201 12.1405 19.1659 12.2937 19.1657C12.4482 19.1625 12.5982 19.1127 12.7238 19.0227C12.8494 18.9327 12.9448 18.8068 12.9973 18.6616L19.1155 1.85776C19.1676 1.72263 19.1802 1.57548 19.1517 1.43348C19.1233 1.29149 19.055 1.16049 18.9549 1.05576Z"
                fill="#246BF9"
            />
        </svg>
    );
}

export default SendIcon;
